import DocumentsAccordion from './styled';

export default DocumentsAccordion;
